var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fa fa-info-circle fa-sm pointer text-primary",attrs:{"title":"Clique para saber mais"},on:{"click":_vm.tip}})
}
var staticRenderFns = []

export { render, staticRenderFns }